import React from 'react';

import './styles.css';

import { Link } from 'react-router-dom';

export default function ModulesCard(props) {
    return(
        <Link className='modules-card' to={props.to ? props.to:''}>
            <span>{props.icon}</span>
            <p>{props.title}</p>
        </Link>
    )
}